var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_c('b-container-fluid',[_c('b',[_vm._v("المادة: "+_vm._s(_vm.data.name))]),_c('br'),_c('b',[_vm._v("الدرس: "+_vm._s(_vm.data.lessons[_vm.lessonIndex].title))]),_c('br'),_c('br'),_c('ZoomMeeting',{attrs:{"meetingId":_vm.meetingIdFromRoute,"userName":_vm.username}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }